import React from "react";

const FAQ: React.FC = () => {
  return (
    <div
      className="md:max-w-[1300px] mx-auto px-3.5 md:px-[50px] mt-10 md:mt-16 mb-[30px] md:mb-[124px]"
      data-astro-cid-al2ca2vr=""
    >
      <div
        className="w-full text-white text-center text-2xl font-black leading-6 text-textMain-0 md:text-3xl md:leading-10 mb-6 md:mb-10 md:text-left"
        style={{ textShadow: "0px 4px 1px rgba(50, 0, 0, 0.3)" }}
        data-astro-cid-al2ca2vr=""
      >
        FAQ
      </div>
      <div
        className="flex flex-col gap-5 md:gap-8 px-1 md:px-6"
        data-astro-cid-al2ca2vr=""
      >
        <div
          className="faq-item text-primary-500 font-source bg-[#ffee86] rounded-lg py-4 px-5 md:p-6"
          data-astro-cid-al2ca2vr=""
        >
          <h3
            className="font-black text-base md:text-2xl flex-between gap-[40px] cursor-pointer md:cursor-default"
            data-astro-cid-al2ca2vr=""
          >
            <div className="text-red-600" data-astro-cid-al2ca2vr="">
              What is a promotion code?
            </div>
            {/* <img
              src="/icons/arrow.svg"
              alt="arrow"
              data-astro-cid-al2ca2vr="true"
              loading="lazy"
              decoding="async"
              fetchPriority="auto"
              width="19"
              height="10"
              className="md:hidden arrow-icon"
            /> */}
          </h3>
          <div
            className="faq-content"
            data-astro-cid-al2ca2vr=""
            // style={{ maxHeight: "0px;" }}
          >
            <p
              className="font-source text-[#130300cc] text-sm md:text-lg tracking-normal pt-2 md:pt-4"
              data-astro-cid-al2ca2vr=""
            >
              A promotion code is an alphanumeric English phrase used during
              checkout to receive an online discount (or other special benefits)
              when purchasing products or services on an e-commerce site.
              <br />
              It's synonymous with coupon codes, discount codes, and voucher
              codes, and is sometimes called an online digital coupon. You can
              search for promotion codes for over 5,000 brands.
              <br />
              Additionally, the CodesSeek website offers detailed educational
              materials about coupons and hints for making smart purchases.
            </p>
          </div>
        </div>
        <div
          className="faq-item text-primary-500 font-source bg-[#ffee86] rounded-lg py-4 px-5 md:p-6"
          data-astro-cid-al2ca2vr=""
        >
          <h3
            className="font-black text-base md:text-2xl flex-between gap-[40px] cursor-pointer md:cursor-default"
            data-astro-cid-al2ca2vr=""
          >
            <div className="text-red-600" data-astro-cid-al2ca2vr="">
              How can I get discounts and promotion codes for my purchases?
            </div>
          </h3>
          <div className="faq-content" data-astro-cid-al2ca2vr="">
            <p
              className="font-source text-[#130300cc] text-sm md:text-lg tracking-normal pt-2 md:pt-4"
              data-astro-cid-al2ca2vr=""
            >
              Finding coupons isn't always easy and can sometimes take time.
              <br />
              We recommend bookmarking codesseek.com. If you use Chrome or Edge,
              you can also install the desktop app.
              <br />
              This makes it much easier to quickly find and see the coupons you
              need, saving you a lot of time.
            </p>
          </div>
        </div>
        <div
          className="faq-item text-primary-500 font-source bg-[#ffee86] rounded-lg py-4 px-5 md:p-6"
          data-astro-cid-al2ca2vr=""
        >
          <h3
            className="font-black text-base md:text-2xl flex-between gap-[40px] cursor-pointer md:cursor-default"
            data-astro-cid-al2ca2vr=""
          >
            <div className="text-red-600" data-astro-cid-al2ca2vr="">
              Are promotion codes useful?
            </div>
          </h3>
          <div className="faq-content" data-astro-cid-al2ca2vr="">
            <p
              className="font-source text-[#130300cc] text-sm md:text-lg tracking-normal pt-2 md:pt-4"
              data-astro-cid-al2ca2vr=""
            >
              Yes, but many offers are valid for a short period. Retailers often
              run promotion code campaigns to stimulate consumer desire to buy,
              and many small retailers use promotion codes all year round.
              <br />
              In fact, our platform provides discount codes for many brands, and
              they are updated weekly for free! You can freely get the brand
              coupons you need.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
